// extracted by mini-css-extract-plugin
export default {"Component":"VideoScreen_Component__R+U00"};